/**
 * データを入力可能か否かを取得する
 * @param values データ
 * @returns true 入力可能(データ無しまたは1レコード有り) / false 入力不可(複数レコード有り)
 */
export function isEnableInput<T>(values?: T[]): boolean {
  return !values || values.length < 2;
}

/**
 * データの存在有無を取得する
 * @param values データ
 * @returns true 有 / false 無
 */
export function isExistValue<T>(values: T[] = []): boolean {
  return values.some((value) => value);
}

/**
 * Date型をハイフン区切り日付文字列へ変換する
 * @param date Date型日付または区切りなし日付文字列(YYYYMMDD)
 * @param separator 区切り文字('-')
 * @returns ハイフン区切り日付文字列
 */
export function convertDateString(date: Date | string | null, separator: string = '-'): string {
  let ymd = '';

  if (date) {
    let dates: string[] = [];

    if (date instanceof Date) {
      // 日付型
      dates = [`${date.getFullYear()}`, `0${date.getMonth() + 1}`.slice(-2), `0${date.getDate()}`.slice(-2)];
    } else {
      // 文字列型
      if (date.length === 8) {
        dates = [date.slice(0, 4), date.slice(4, 6), date.slice(6, 8)];
      }
    }

    ymd = dates.join(separator);
  }

  return ymd;
}

/**
 * 区切り日付文字列を区切りなし日付文字列へ変換する
 * @param dateString 区切りあり日付文字列(YYYY/MM/DD)
 * @param separator 区切り文字('/')
 * @returns 区切りなし日付文字列(YYYYMMDD)
 */
export function removeDateStringSeparator(dateString: string, separator: string = '/'): string {
  const ymd = dateString.split(separator);
  return `${ymd[0]}${('0' + ymd[1]).slice(-2)}${('0' + ymd[2]).slice(-2)}`;
}

/**
 * formattedSystemDateを区切りなし日付文字列へ変換する
 * @param 日時文字列(YYYY/MM/DD HH:MM:SS)
 * @returns 区切りなし日付文字列(YYYYMMDD)
 */
export function getDateString(formattedSystemDate: string): string {
  return removeDateStringSeparator(formattedSystemDate.split(' ')[0]);
}

/**
 * オブジェクトを再帰的に捜査し、undefined、もしくはnullであるプロパティを削除する(破壊的)
 * @param obj 対象のオブジェクト
 */
export function removeUndefinedOrNullProperties(obj: { [key: string]: any }): void {
  for (const prop in obj) {
    if (obj[prop] === undefined || obj[prop] === null) {
      delete obj[prop];
    } else if (typeof obj[prop] === 'object') {
      removeUndefinedOrNullProperties(obj[prop]);
    }
  }
}
